<template>
    <div
        class="block-map"
        :class="device_platform"
    >
        <yandex-map
            @map-was-initialized="mapInit"
            ymap-class="ymap"
            :zoom="14"
            :coords="[coords.y, coords.x]"
            :controls="[]"
            :scrollZoom="false">
            <ymapMarker
                :coords="marker_coords"
                :icon="markerIcon"
                markerId="Kuntsevo"
            />
        </yandex-map>
        <div class="block-map__contacts">
            <a href="https://kuntsevo.com/?utm_source=sale_kuntsevo_com" target="_blank" class="logo">
                <div class="logo__img"></div>
            </a>

            <block-contacts
                class="block-map__contact-info"
            />

            <p class="block-map__contacts-text">
                Перейти в <a href="https://yandex.ru/maps/213/moscow/?ll=37.3743102%2C55.7254598&mode=routes&routes%5BtimeDependent%5D%5Btime%5D=2020-01-27T10%3A46%3A00&routes%5BtimeDependent%5D%5Btype%5D=departure&rtext=~55.7254598%2C37.3743102&rtt=comparison&ruri=~ymapsbm1%3A%2F%2Fgeo%3Fll%3D37.374%252C55.726%26spn%3D0.001%252C0.001%26text%3D%25D0%25A0%25D0%25BE%25D1%2581%25D1%2581%25D0%25B8%25D1%258F%252C%2520%25D0%259C%25D0%25BE%25D1%2581%25D0%25BA%25D0%25B2%25D0%25B0%252C%2520%25D1%2583%25D0%25BB%25D0%25B8%25D1%2586%25D0%25B0%2520%25D0%2593%25D0%25BE%25D1%2580%25D0%25B1%25D1%2583%25D0%25BD%25D0%25BE%25D0%25B2%25D0%25B0%252C%252014&z=13" target="_blank" class="block-map__contacts-link">Яндекс.Навигатор</a>
            </p>

            <callback-input
                :data="{type: 'sale', form: 'contacts'}"
            >
                Позвоните мне
            </callback-input>
        </div>
    </div>
</template>

<script>
import { yandexMap, ymapMarker } from 'vue-yandex-maps'
import BlockContacts from '@/components/block-contacts'
import CallbackInput from '@/components/callback-form/callback-input'
import Mixin from '@/common/mixin.js'

export default {
    name: 'block-map',
    mixins: [Mixin],
    components: {
        yandexMap,
        ymapMarker,
        BlockContacts,
        CallbackInput
    },
    data() {
        return {
            coords: this.CONSTANTS.center_coords,
            marker_coords: [this.CONSTANTS.offices[0].coords.y, this.CONSTANTS.offices[0].coords.x],
            markerIcon: {
                layout: 'default#imageWithContent',
                imageSize: [48, 48],
                imageOffset: [-15, -40],
                content: 'some content',
                contentLayout: `
                <div style="color: red; font-weight: bold;">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="48px" height="48px" viewBox="0 0 48 48" enable-background="new 0 0 48 48" xml:space="preserve">
                        <image id="image0" width="48" height="48" x="0" y="0" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABHVBMVEX////eJyfeJyfeJyfe JyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfe JyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfe JyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfe JyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfe JyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyfeJyf////Nl2FSAAAAXXRSTlMA AAEzgr/Y9NeBMlbZVCPJxyE86exCQfr5P+okxldTsAtAsjF3eoCzvfMMDfUO4N+4tLd8OwLl54yL /f4lsS0wqqkm+/wpnxfu8BlnZsTIeXgDHSBbmJcHzNAJPWnLdcqQAAAAAWJLR0QAiAUdSAAAAAlw SFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+QCGw0iMDVqlRUAAAF5SURBVEjH3ZXZWsIwEIVJoRQU wSotrSugiOCKUjcEdxQVV9zJ+7+G8OGkQCdJvdRzl5nzt1/TyUkg8K9EfqQEQ2pY0yJqdARKRAAo ozHKFB5TZEA8QQc0rouBiUk6pKQhAswU9ciy+YA+RRElp3mAkqCoZhQOMEs5msMBJcYDIjgQdB3z djqdybrrBRQIsf5i72/lWGEJBVT2fBiIPFSWUYB9gg2AyUYEBQrQLgKwApUCCqx6gDWoaCiwDu0M AAZUNlBgE9pZAEpQ2UKBKNvFXM+/LdnWsvuj8maxaJTcdRkFnB3eaOw6+PDt8YB9zrTGD3B/5ZB3 gKo4UOWeuBr6isoR/0wfY8CJIAROz7z+8wtRzNS9QF2YS5dXw/7GtTj5boaBW0lUOs1B/50jC+Oa 1e+3atL0Jvf9wIM87omjuv7mow+APLGdajz7uFA6agHQ8nMDdfXS878Sv8Dbe9f/8ekbIHqycy3o xD9AvqyUQX4DkHabSIE/q28GF/Jrf0ZEyQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMC0wMi0yN1Qx MzozNDo0OCswMzowMEQxrAEAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjAtMDItMjdUMTM6MzQ6NDgr MDM6MDA1bBS9AAAAAElFTkSuQmCC"/>
                    </svg>
                </div>`
            }
        }
    },
    mounted() {
        window.addEventListener('keydown', (e) => {
            if (e.shiftKey) {
                window.mapa.behaviors.enable('scrollZoom');
            }
        });

        window.addEventListener('keyup', (e) => {
            window.mapa.behaviors.disable('scrollZoom');
        });
    },
    methods: {
        mapInit(data) {
            window.mapa = data;
        }
    }
}
</script>

<style lang="scss">

.ymap {
    width: 100%;
    height: 660px;
}

.logo {
    &__img {
        width: 190px;
        height: 45px;

        background-image: url("../img/logo.png");
        background-size: contain;
        background-position: 0 center;
        background-repeat: no-repeat;
    }
}

.block-map {
    position: relative;

    &__contact-info {
        margin-top: 30px;
    }

    &__contacts {
        position: absolute;
        top: 75px;
        left: 300px;
        z-index: 100;

        width: 450px;
        padding: 40px;

        background-color: #f8f8f8;
    }

    &__contacts-text {
        display: flex;
        align-items: center;

        white-space: pre;
        color: #006db0;

        &::before {
            content: '';
            display: block;
            width: 30px;
            height: 30px;
            margin-right: 10px;

            background-image: url("../img/icons/navigator.png");
        }
    }

    &__contacts-link {
        color: #f7c70a;
    }
}

.tablet {
    .block-map {
        &__contacts {
            left: 20px;
        }
    }
}

.mobile {
    .ymap {
        height: 740px;
    }

    .block-map {
        &__contacts {
            left: 0;
            bottom: 0;
            top: auto;

            width: 90%;
            padding: 5%;
        }
    }
}
</style>